import isEmpty from "lodash/isEmpty";
import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import http from "utilities/http";
import { Loader } from "components/loader";
import {getCookie, setCookie} from "framework/libs/cookie";

export default function Poll({ pollData, user }) {
    if(!pollData) return <></>;
    const token = user?.id || '';
    const key = `${token}-${pollData.id}-poll-hpn`;
    const cookie = getCookie(key);

    const listQuestion = pollData.questions?.data || [];
    const initAnswers = {};

    pollData.questions?.data.forEach(question => {
        //Get init answers from cookie
        initAnswers[question.id] = question.answers.data
            .filter(answer => cookie.some(cookieAnswerId => cookieAnswerId == answer.id))
            .map(answer => ({
                answer_id: answer.id,
                content: answer.content,
            }));
    });

    const [isDisable, setIsDisable] = useState(true);
    const [loading, setLoading] = useState(false);
    const [answers, setAnswers] = useState(initAnswers);
    const [resResult, setResResult] = useState({});

    //Modal
    const [done, setDone] = useState(!isEmpty(cookie));
    const [display, setDisplay] = useState(false);
    const handleClose = () => setDisplay(false);
    const handleDisplay = () => {
        fetchResult();
        setDisplay(true);
    };

    //Function
    const select = (e, isMulti, questionId, answerId, answerContent) => {
        const newAns = Object.assign({}, answers);

        if(!isMulti) {
            newAns[questionId] = [{
                answer_id: answerId,
                content: answerContent
            }];
        } else {
            if (e.target.checked) {
                newAns[questionId].push({
                    answer_id: answerId,
                    content: answerContent
                });
            } else {
                newAns[questionId] = newAns[questionId].filter(x => x.answer_id != answerId);
            }
        }

        setAnswers(newAns);
    };

    const answer = async () => {
        try {
            setLoading(true);
            const body = Object.keys(answers).map(x => {
                return {
                    question_id: x,
                    answers: answers[x]
                };
            });
    
            const res = await http(`poll/${pollData.id}/answer`, {}, {
                body: body,
                method: 'POST',
            }, 'v2');
            
            if (res.code == 200) {
                setDone(true);
                handleDisplay();
                const valueCookies = [];
                Object.keys(answers).forEach(x => {
                    answers[x].forEach(a => valueCookies.push(a.answer_id));
                });
                setCookie(key, valueCookies, 30);
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    // Set unable button when answer all question
    useEffect(() => {
        if (!Object.values(answers).some(x => isEmpty(x))) setIsDisable(false);
    }, [answers]);

    useEffect(() => {
        fetchResult();
    }, []);

    useEffect(() => {
        setDone(!isEmpty(cookie));
        setAnswers(initAnswers);
    }, [user]);

    const fetchResult = async () => {
        const res = await http(`poll/${pollData.id}/result`, {}, {}, 'v2');
        if(res.code == 200) {
            setResResult(res.data);
        }
    };

    const result = (resResult.question || []).map((item, index) => {
        return <>
            <div key={'question' + item.id + index} className="poll-question">
                <p>{item.title}</p>
            </div>
            <div key={'answer' + item.id + index} className="poll-answer">
                {(item.answers || []).map((ans, index) => {
                    ans.percent = ans.percent || 0;
                    return <div key={'' + item.id + ans.id + index} className="result-answer-content">
                        <div className="result-answer-content-sub">
                            <div className="result-answer-content-text">
                                <div className="result-answer-content-label">
                                    {
                                        answers[item.id].some(x => x.answer_id == ans.id)
                                            ? <><img src="/images/Radio-tick.svg"/> <p className="c-blue">{ans.title}</p></>
                                            : ans.title
                                    }
                                    
                                </div>
                                <div className="result-answer-content-percent">
                                    <p>{Math.round(ans.percent * 100)/100 + '%'}</p>
                                </div>
                            </div>
                            <div className="result-answer-content-progress">
                                <div className="no-selected"></div>
                                <div className="selected" style={{ width: ans.percent + '%' }}></div>
                            </div>
                        </div>
                    </div>;
                })}
            </div>
        </>;
    });

    return (
        <>
            <Loader loading={loading} />
            <div className="poll-card">
                <div className="poll-header">
                    <div className="poll-title">
                        {pollData.title}
                    </div>
                    {/* <div className="poll-description">
                        {pollData.description}
                    </div> */}
                </div>

                {!done && listQuestion.map((item, index) => {
                    return <>
                        <div key={'question' + item.id + index} className="poll-question">
                            <p>{item.title}</p>
                            {/* <div dangerouslySetInnerHTML={{__html: item.description || item.title}}></div> */}
                        </div>
                        <div key={'answer' + item.id + index} className="poll-answer">
                            {item.type === 'mcq' && (item?.answers?.data || []).map((ans, i) => {
                                return <div key={'' + item.id + ans.id + i} className="poll-answer-content">
                                    <input type="radio" name={item.id} className="poll-answer-checkbox" onClick={(e) => select(e, false, item.id, ans.id, ans.content)} />
                                    <span className="poll-answer-label">{ans.content}</span>
                                </div>;
                            })}

                            {item.type === 'multi' && (item?.answers?.data || []).map((ans, i) => {
                                return <div key={'' + item.id + ans.id + i} className="poll-answer-content">
                                    <input type="checkbox" className="poll-answer-checkbox" onClick={(e) => select(e, true, item.id, ans.id, ans.content)} />
                                    <span className="poll-answer-label">{ans.content}</span>
                                </div>;
                            })}
                        </div>
                    </>;
                })}

                {done && result}

                {!done && <div className="poll-footer">
                    <div className="poll-button-group">
                        <button className="btn c-blue" onClick={handleDisplay}>Xem kết quả</button>
                        <button className="btn btn--blue" disabled={isDisable} onClick={answer}>Gửi câu trả lời</button>
                    </div>
                </div>}
            </div>

            <Modal size="lg" show={display} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{done && 'Cảm ơn bạn đã tham gia '} {pollData.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="poll-card-modal">
                        {result}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};